import { useCallback, useEffect, useRef } from "react";
import StyledMenu from "components/styled/Menu.styled";
import { Link } from "react-router-dom";
import BubbleTalk from "components/BubbleTalk";
import scenarios from "data/scenarios";
import bodyTalkLogo from "assets/logos/body-talk-logo.png";
import familyPlanningLogo from "assets/logos/fpnsw-logo.png";
import MenuButtons from "./MenuButtons";
import { ArrowLeft } from "components/Icons";
import { useAppContext } from "context/AppContext/AppContext";
import { restart } from "context/AppContext/actions";

const Menu = ({ isMenuOpen, setIsMenuOpen }) => {
  const menuRef = useRef(null);

  const { dispatch } = useAppContext();

  const handleCloseMenu = (e) => {
    e.stopPropagation();
    setIsMenuOpen(false);
  };

  const handleClickOutsideMenu = useCallback(
    (e) => {
      e.stopPropagation();
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    },
    [setIsMenuOpen]
  );

  const handleBackToStart = () => {
    dispatch(restart());
    setIsMenuOpen(false);
  };

  useEffect(() => {
    window.addEventListener("click", handleClickOutsideMenu);

    return () => {
      window.removeEventListener("click", handleClickOutsideMenu);
    };
  }, [handleClickOutsideMenu]);

  return (
    <StyledMenu isMenuOpen={isMenuOpen} ref={menuRef}>
      <div className="menu-header">
        <div className="menu__logos">
          <a href="https://bodytalk.org.au/" target="_blank" rel="noreferrer" className="body-talk-logo logo-item">
            <img src={bodyTalkLogo} alt="body-talk" />
          </a>
          <a href="https://www.fpnsw.org.au/" target="_blank" rel="noreferrer" className="family-planning-logo logo-item">
            <img src={familyPlanningLogo} alt="family-planning-nsw" />
          </a>
        </div>
        <MenuButtons isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      </div>
      <div className="button-back-to-start">
        <button onClick={handleBackToStart}>
          <ArrowLeft color="#595959" />
          <span className="label">Back to start</span>
        </button>
      </div>
      <div className="menu__items-listing">
        {Object.keys(scenarios).map((key, index) => (
          <div key={scenarios[key].title} className="scenario-item" onClick={handleCloseMenu}>
            <Link to={scenarios[key].path}>
              <BubbleTalk backgroundColor={scenarios[key].backgroundColor} arrow={index % 2 !== 0 ? "left" : "right"}>
                <div className="scenario-bubble">
                  <div className="scenario-bubble-title">{scenarios[key].title}</div>
                  <div className="scenario-bubble-description">{scenarios[key].description}</div>
                </div>
              </BubbleTalk>
            </Link>
          </div>
        ))}
      </div>
    </StyledMenu>
  );
};

export default Menu;
